/* istanbul ignore file */
import React from "react";
import { ToelichtingWerkloosheidHoofdstuk } from "../../../../../.generated/rapportage/rapportagetypes";
import { InkomensanalyseTabelWerkloosheid } from "../../../scenarios/werkloosheid-drawer";
import { Chapter } from "../../../components/Chapter";
import Heading from "../../../components/Heading";
import { ReactElement } from "react-markdown/lib/react-markdown";
import { Motivering } from "../../../components/Motivering";

export const ScenarioWerkloosheidChapter = ({
  scenarioWerkloosheid,
  selectedAanvrager,
}: {
  scenarioWerkloosheid: ToelichtingWerkloosheidHoofdstuk;
  selectedAanvrager?: "Aanvrager1" | "Aanvrager2";
}): ReactElement => {
  const dashboardSettings = scenarioWerkloosheid.dashboard?.werkloosheid;

  const klantVolgNummer = selectedAanvrager === "Aanvrager2" ? 2 : 1;
  const motivering =
    scenarioWerkloosheid.motivering?.find(
      (x) => x.klantVolgnummer === klantVolgNummer
    ) || null;
  const isScenarioForAanvrager1 = selectedAanvrager === "Aanvrager1";

  const nonWorker = isScenarioForAanvrager1
    ? motivering?.klantNaamAanvrager || "Aanvrager"
    : motivering?.klantNaamPartner || "Partner";

  const motiveringKeuzes =
    selectedAanvrager === "Aanvrager1"
      ? scenarioWerkloosheid?.motiveringKeuzesAanvrager1
      : scenarioWerkloosheid?.motiveringKeuzesAanvrager2;

  return (
    <Chapter>
      <div className="break-avoid">
        <Heading level={3} text={`Bij werkloosheid van ${nonWorker}`} />
        <Motivering
          wens={motiveringKeuzes?.wensen ?? null}
          advies={motiveringKeuzes?.advies ?? null}
          keuze={motiveringKeuzes?.keuze ?? null}
        />
      </div>
      {motivering && dashboardSettings && (
        <InkomensanalyseTabelWerkloosheid
          motiveringOutput={motivering}
          dashboardSettings={dashboardSettings}
          selectedAanvrager={selectedAanvrager}
        />
      )}
    </Chapter>
  );
};
